import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import Popup01 from "../popup/Popup01"
import * as API from "../../libs/service";
import { setEdu } from "../../redux/licenseSlice";

export default function PopupUpdateEdu(props) {
    const {
        title,
        subTitle,
        text,
        lefttext,
        width,
        button,
        buttonCancel,
        func,
        setFunc,
        noneLoading,
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        text1,
        text2,
        text3,
        text1_b,
        text2_b,
        text3_b,
        max_width,
        updateEdu,
        updateEduEmail
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [LicenseidValue, setLicenseIdValue] = useState('');
    const [LicenseidErr, setLicenseIdErr] = useState(0);
    const [LicenseidSuc, setLicenseIdSuc] = useState(false);
    const [educationStep, setEducationStep] = useState(1);
    const [time, setTime] = useState(60 * 3);
    const [timecut, setTimecut] = useState(false);
    const [code, setCode] = useState('');
    const [codeErr, setCodeErr] = useState(false);
    const [codeSuc, setCodeSuc] = useState(false);

    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    useEffect(() => {
        if (!LicenseidValue) {
            setLicenseIdErr(1);
        }
    }, [LicenseidValue]);

    useEffect(() => {
        if (educationStep === 1 && time > 0) {
            const timer = setInterval(() => {
                setTime(prevTime => {
                    if (prevTime === 1) {
                        setTimecut(true);
                    }
                    return prevTime - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        } else if (time === 0) {
            setTimecut(true);
        }
    }, [educationStep, time]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    const setFunction = () => {
        if (setFunc) setFunc();
        dispatch(close());
    };

    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "education_pop_input") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setLicenseIdValue(value)

            if (!EmailChk.test(value)) {
                setLicenseIdErr(1);
                setLicenseIdSuc(false);
                return;
            } else {
                setLicenseIdErr(0);
            }

            if (value && EmailChk.test(value)) {
                setLicenseIdSuc(true)
            } else {
                setLicenseIdSuc(false)
            }
        }

        if (name === "code") {
            const onlyNumbers = /^[0-9]*$/;
            setCode(value);

            if (onlyNumbers.test(value)) {
                if (value.length === 4) {
                    setCodeSuc(true);
                } else {
                    setCodeSuc(false);
                }
            }
        }
    }

    const LicenseSucChk = async () => {
        console.log("educationStep : ", educationStep);
        if (educationStep === 0) {
            dispatch(loadingStart());

            if (LicenseidSuc) {
                setTimeout(() => {
                    setEducationStep(1);
                    dispatch(loadingEnd());
                }, 1000)
            } else {
                setLicenseIdErr(1);
                setTimeout(() => {
                    setEducationStep(3); // 파트너 기관 메일이 아닐시 테스트
                    dispatch(loadingEnd());
                }, 1000)
            }
        }

        if (educationStep === 1) {
            dispatch(loadingStart());

            if (codeSuc) {
                const res = await API.get(`etc/partnercode/${mbData.mb_email}/${code}`);
                console.log("res : ", res);
                if (res?.data?.msg === 'success') {
                    dispatch(setEdu(res?.data?.license));
                    setEducationStep(2);
                } else if (res?.data?.msg === 'err1') {
                } else if (res?.data?.msg === 'err2') {
                    setCodeErr(1);
                } else if (res?.data?.msg === 'err3') {
                    dispatch(open({
                        component:
                            <Popup01
                                x_btn={true}
                                text1={lang === 0 ? '오류가 발생했습니다.' : 'An error has occurred.'}
                                longButton={lang === 0 ? '확인' : 'OK'}
                            />
                    }));
                }

                dispatch(loadingEnd());
            } else {
                setTimeout(() => {
                    dispatch(open({
                        component:
                            <Popup01
                                x_btn={true}
                                text1={lang === 0 ? '오류가 발생했습니다.' : 'An error has occurred.'}
                                longButton={lang === 0 ? '확인' : 'OK'}
                            />
                    }));
                    dispatch(loadingEnd());
                }, 1000)
            }
        }
    }

    return (
        <>
            <div
                className={"popup_default01"}
                style={{
                    maxWidth: max_width ? max_width : '400px',
                    width: '100%',
                    marginLeft: 10,
                    marginRight: 10,
                }}
            >
                {x_btn &&
                    <div
                        className="popup_x_btn_box edu_license"
                    >
                        <p className="title">{lang === 0 ? 'UModeler X School 신청' : 'Apply for UModeler X School'}</p>
                        <img src={require("../../assets/images/exit-icon.svg").default}
                            className="popup_x_btn"
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                    </div>
                }
                <div
                    className={`popup_content_box edu_license ${educationStep === 0 ? 'step0' : educationStep === 1 ? 'step1' : educationStep === 2 ? 'step2' : 'step3'}`}
                >
                    {text1 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text1}</p>
                        </div>
                    }

                    {text1_b && // 마진 위아래 있음
                        <div
                            className="popup_text_box mar"
                        >
                            <b>{text1_b}</b>
                        </div>
                    }

                    {text2 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text2}</p>
                        </div>
                    }

                    {text2_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text2_b}</b>
                        </div>
                    }

                    {text3 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text3}</p>
                        </div>
                    }

                    {text3_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text3_b}</b>
                        </div>
                    }

                    {title &&
                        <div
                            className="popup_title_box"
                        >
                            <p>{title}</p>
                        </div>
                    }

                    {subTitle &&
                        <div
                            className="popup_sub_title_box"
                        >
                            <p>{subTitle}</p>
                        </div>
                    }
                    {text &&
                        <div
                            className="popup_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{text}</p>
                        </div>
                    }

                    {lefttext &&
                        <div
                            className="popup_left_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{lefttext}</p>
                        </div>
                    }

                    {educationStep == 1 &&
                        <div className="education_pop_box">
                            <div className="text_box step1">
                                <p>{updateEduEmail}</p>
                                <p className="sub">{lang === 0 ? '이메일로 인증번호를 전송했습니다.' : 'A verification code has been sent to your email.'}</p>
                            </div>

                            <div className="login_input_box">
                                <div
                                    className="input_div"
                                    style={{
                                        marginTop: '20px',
                                    }}
                                >
                                    <input
                                        type="text"
                                        placeholder={lang === 0 ? "인증번호 입력" : 'Enter Code'}
                                        className="input_id"
                                        name="code"
                                        value={code}
                                        onChange={InputChange}
                                        maxLength={4}
                                    />
                                    <span
                                        style={{
                                            color: '#0E6AF4',
                                            fontSize: '12px',
                                            position: 'absolute',
                                            right: '12px',
                                            top: 'calc(50% - 10px)'
                                        }}
                                    >
                                        {formatTime(time)}
                                    </span>
                                </div>
                            </div>

                            {codeErr === 1 && <span className="err_msg id" style={{ marginTop: '-12px', textAlign: 'center' }}>{lang === 0 ? '인증번호가 일치하지 않습니다.' : 'The verification code does not match.'}</span>}
                            {codeErr === 2 && <span className="err_msg id" style={{ marginTop: '-12px', textAlign: 'center' }}>{lang === 0 ? '인증번호가 만료되었습니다 다시 시도해 주세요.' : 'The verification code has expired. Please try again.'}</span>}

                            <button
                                type="button"
                                className={`custom_btn ${!codeSuc ? 'off' : ''}`}
                                onClick={() => {
                                    if (timecut) {
                                        setCodeErr(2);
                                    } else if (!code) {
                                        setCodeErr(1);
                                    } else if (codeSuc) {
                                        LicenseSucChk()
                                    }
                                }}
                            >
                                {lang === 0 ? '확인' : 'OK'}
                            </button>
                        </div>
                    }

                    {educationStep == 2 &&
                        <div className="education_pop_box">
                            <div className="text_box step2">
                                <img src={require("../../assets/icon/update_edu_suc.svg").default} />
                                <p style={{ marginTop: '24px' }}>{lang === 0 ? '갱신 되었습니다.' : 'Renewal Successful.'}</p>
                            </div>
                        </div>
                    }

                    {/* {educationStep == 2 &&
                        <div className="education_pop_box">
                            <div className="text_box step1 step2">
                                <p>Unity School Plan 또는<br />파트너 기관의 이메일이 아닙니다.</p>
                                <span className="blue">[문의 하기]</span>를 통해 학생 또는<br />교육기관 관계자 임을 증빙해주세요.
                            </div>
                        </div>
                    } */}

                    {/* {educationStep == 0 &&
                        <>
                            {(buttonCancel || button || longButton) &&
                                <div className="popup_btn_box edu_license">
                                    {buttonCancel && (
                                        <button
                                            className="button_cancel"
                                            onClick={() => {
                                                if (func === "setRightFunc") {
                                                    setFunction();
                                                } else {
                                                    if(cancelFunc) cancelFunc();
                                                    dispatch(close());
                                                }
                                            }}
                                        >
                                            {buttonCancel}
                                        </button>
                                    )}
                                    {button && (
                                        <button
                                            className={`button_success ${!LicenseidSuc ? 'license_edu_off' : ''}`}
                                            onClick={() => {
                                                LicenseSucChk();
                                            }}
                                        >
                                            {button}
                                        </button>
                                    )}
                                    {longButton && (
                                        <button
                                            className="button_success long"
                                            onClick={() => {
                                                if (func === "setRightFunc") {
                                                    dispatch(close());
                                                } else {
                                                    setFunction();
                                                }
                                            }}
                                        >
                                            {longButton}
                                        </button>
                                    )}
                                </div>
                            }
                        </>
                    } */}
                </div>
            </div>
        </>
    );
}